import { render, staticRenderFns } from "./PlaceholderTip.vue?vue&type=template&id=fe916122&lang=pug"
import script from "./PlaceholderTip.vue?vue&type=script&lang=js"
export * from "./PlaceholderTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports